var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V496H16V336H496Z",
    fill: "#479951"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V336H16V176H496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16V176H16V16H496Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L176 256.002L16 496V16Z",
    fill: "#C0392B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.686 198.085C236.701 198.085 210.771 224.014 210.771 256C210.771 287.985 236.701 313.915 268.686 313.915C272.399 313.915 276.027 313.542 279.545 312.874C252.752 307.79 232.49 284.272 232.49 256C232.49 227.728 252.754 204.211 279.545 199.126C276.026 198.458 272.4 198.085 268.686 198.085Z",
    fill: "#C0392B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.124 291.047L277.82 273.393L302.322 291.313L293.164 262.372L317.779 244.606L287.423 244.373L278.134 215.473L268.531 244.27L238.175 244.175L262.596 262.206L253.124 291.047V291.047Z",
    fill: "#C0392B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEh);
export default __webpack_public_path__ + "static/media/EH.4f72dd3be851d9f5d4c85c3e3f6249e7.svg";
export { ForwardRef as ReactComponent };